import {
  BuyNGetMMarketingCampaignConfig,
  MarketingCampaignType,
  MarketingCampaignDiscountType,
  Offer,
} from "../1_types/genericTypes";
import { isOptionListTarget } from "./marketingCampaign";
import { getProductPriceWithOptions } from "./";
export { sumOptionLevelPromotionAmount } from "./cartLineDiscount";
import _ from "lodash";
import { KEY_PREFIX } from "../constants";

export const isBngmOptionListOffer = (offer: Offer): boolean => {
  if (offer?.type !== MarketingCampaignType.BUY_N_GET_M_CHEAPEST_AT_DISCOUNT)
    return false;
  const target = (offer.config as BuyNGetMMarketingCampaignConfig)?.target;
  return isOptionListTarget(target);
};

export const isBngmOffer = (offer: Offer): boolean =>
  offer?.type === MarketingCampaignType.BUY_N_GET_M_CHEAPEST_AT_DISCOUNT;
export const getBngmOptionValue = (
  option: { position?: number } | null | undefined,
  offer: Offer | null | undefined,
): number | undefined =>
  option?.position ?? (isBngmOffer(offer) ? 0 : undefined);
const hasText = (value: unknown): value is string =>
  typeof value === "string" && value.trim().length > 0;
export const getBngmOfferCategoryKey = (key) => `${KEY_PREFIX.OPTION}${key}@0`;

export const getBngmPreviewTotalFromUnitPrice = (
  fullUnitPrice: number,
  discountAmount: number,
  quantity: number,
): number =>
  Math.round(Math.max(0, fullUnitPrice - discountAmount) * quantity * 100) /
  100;
export const getBngmCampaignDiscountAmount = (
  productItems: any[],
  offer: Offer | null | undefined,
): number => {
  if (!isBngmOffer(offer) || !hasText(offer.key)) return 0;

  const config = offer.config as BuyNGetMMarketingCampaignConfig;

  if (config.discount?.type !== MarketingCampaignDiscountType.PERCENTAGE) {
    return 0;
  }

  const campaignPrices: number[] = [];

  _.forEach(productItems, (item) => {
    if (item?.categoryKey !== getBngmOfferCategoryKey(offer.key)) return;

    _.forEach(_.values(item.options), (option: any) => {
      if (option?.isFree || !option?.price) return;

      const optionPrice = Number.parseFloat(option.price);

      if (Number.isFinite(optionPrice)) {
        campaignPrices.push(optionPrice);
      }
    });
  });

  campaignPrices.sort((a, b) => b - a);

  const numProductsPaid = Math.max(0, config.numProductsPaid ?? 0);
  const discountValue = Math.max(0, config.discount.value ?? 0);

  const discountedBase = _.sum(campaignPrices.slice(numProductsPaid));

  return (discountedBase * discountValue) / 100;
};
export const getBngmPreviewTotal = (
  basePrice: number,
  productItems: any[],
  offer: Offer,
  quantity: number,
  sectionKey: string,
): number => {
  const fullUnitPrice = getProductPriceWithOptions(
    basePrice,
    productItems,
    sectionKey,
  );
  return getBngmPreviewTotalFromUnitPrice(
    fullUnitPrice,
    getBngmCampaignDiscountAmount(productItems, offer),
    quantity,
  );
};
